import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function findWalletVoucher(voucherId) {
  return new Promise((resolve, reject) => {
    authToken()
      .then((token) => {
        axios
          .get(cfac22('API_HOST_V2') + '/vouchers/findWalletVoucher?voucherId=' + voucherId, {
            headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
          })
          .then((result) => {
            //console.log("RESULTADO API FIND VOUCHER ===>: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERRO API FIND VOUCHER ===>: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        // console.log("ERROR_TOKEN===>", error);
        reject(error);
      });
  });
}
